import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DevicesV4Component } from '../devices-v4/devices-v4.component';
import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { DataTableConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as Highcharts from 'highcharts';
import { parse } from 'path';

@Component({
  selector: 'app-r4-conversions',
  templateUrl: './r4-conversions.component.html',
  styleUrls: ['./r4-conversions.component.css']
})
export class R4ConversionsComponent extends DevicesV4Component implements OnInit {

  @Input() externalwidgetsconfiguration: any;
	@Input() metricsarray: any;

	public widgetsConfiguration;
  public totalsArray = [];
	public metricsArray = [];
	public metricObject;
	public deviceChartDataObjArray;
  public initialAxisDataSrc = {
		allowZeroData: true,
		colorPalette: {
			color: '',
			isCustom: false
		},
		dataLabels: {
			enabled: true
		},
		dataType: 'number',
		displayName: '',
		format: '',
		readFrom: 'conversions',
		rowIdentity: {
			key: 'conversion_action',
			value: ''
		},
		showInSeries: 'true'
	};
  public daypartColors = ['primary', 'secondary', 'tertiary', 'quaternary', 'quinary'];
	responseData: any;
	groupByData: any;
  public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 500,
		dynamicTitle: true,
    allowTitleHTML: true,
		position: 'top',
		scale: 'small'
	};

  constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

  ngOnInit(): void {
    super.ngOnInit();
    this.widgetsConfiguration = this.externalwidgetsconfiguration
			? JSON.parse(decodeURI(this.externalwidgetsconfiguration))
			: null;
		this.metricsArray = JSON.parse(decodeURI(this.metricsarray));
		if (this.metricsArray) {
			this.metricsArray = _.filter(this.metricsArray, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
    this.selectedLegendName = 'conversions';
	this.reloadGraph();
  }

  reload(): void {
	this.reloadGraph();
	this.processResponseData(this.responseData);
  }

  reloadGraph(): void {
	if(window.innerHeight < 720) {
		this.widgetsConfiguration.chartConfig.chart = 
		{
			"type": "pie",
			"marginTop": 0,
			"height": "38%",
			"marginBottom": 60,
			"spacing": [0,0,0,0]
		}
	} else {
		this.widgetsConfiguration.chartConfig.chart = 
		{
			"type": "pie",
			"marginTop": 40,
			"height": "50%",
			"marginBottom": 90,
			"spacing": [0, 0, 0, 0]
		}
	}
  }

  processResponseData(responseData: any): void {
    for (const metric of this.metricsArray) {
			if (metric) {
				const sum_conversions = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				const all_conv_sum = responseData.reduce((s, f) => s + Number(f['all_conversions']), 0);
				this.totalsArray['conversions'] = sum_conversions;
				this.totalsArray['all_conversions'] = all_conv_sum;
				this.totalsArray['conversion_rate'] = ((sum_conversions / parseInt(responseData[0].clicks)) * 100).toFixed(2);
			}
		}

		this.metricObject = [
			{
				name: 'CONVERSIONS',
				value: this.totalsArray['conversions'].toLocaleString(),
				tooltip:
					'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
			},
			{
				name: 'CONVERSION RATE',
				value: this.totalsArray['conversion_rate'] + '%',
				tooltip: 'The average number of conversions per ad interaction, as a percentage.'
			},
			{
				name: 'ALL CONVERSIONS',
				value: this.totalsArray['all_conversions'].toLocaleString(),
				tooltip:
					'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
			}
		];

		this.deviceData = this.conversionsDataProcess(responseData);
    this.generateAxisLabelsSoruce();
    this.widgetsConfiguration.chartConfig.toolTip.formatter = this.getToolTipFormatter();
    this.deviceChartDataObjArray = this.buildDeviceChartCollatorByFields(this.deviceData);
		this.setGraphData(this.deviceChartDataObjArray);
  }

  conversionsDataProcess(responseData: any) {
		if (responseData?.length <= 5) {
			responseData = responseData;
		} else {
			let tempAllConversions = 0;
			let tempCoversions = 0;
			let tempclicks = 0;
			let tempTooltip = null;

			for (let i = 4; i < responseData?.length; i++) {
				tempAllConversions += parseFloat(responseData[i]['all_conversions']);
				tempCoversions += parseFloat(responseData[i]['conversions']);
				tempclicks = parseFloat(responseData[i]['clicks']);
				tempTooltip = responseData[i]['tooltip'];
			}
			let tempDataArray = {
				all_conversions: tempAllConversions,
				conversion_action: 'Additional',
				conversions: tempCoversions,
				clicks: tempclicks,
				tooltip: 'All other conversion actions.'
			};
			let updatedRespData = responseData.splice(0, 4);
			updatedRespData.splice(4, 0, tempDataArray);
      updatedRespData.forEach((item) => {
        item['all_conversions'] = parseFloat(item['all_conversions']);
        item['conversions'] = parseFloat(item['conversions']);
        item['clicks'] = parseFloat(item['clicks']);
		item['tooltip'] = item['tooltip'];
      });
			responseData = updatedRespData;
			this.responseData = responseData;
		}
		this.groupByData = responseData.filter((obj) => {
			return obj['conversions'] != 0 || obj['all_conversions'] != 0;
		});
		return this.groupByData;
	}

  buildDeviceChartCollatorByFields(deviceData: any): any[] {
		const fieldChartArray: any[] = [];
		for (const field of this.fields) {
			const chartObjArray: any[] = [];
			const chartData: any = {};
			const seletedLegend = this.legend.filter((legendObj) => legendObj.value === field);
			for (let i = 0; i < deviceData.length; i++) {
				const chartObj: any = {};
				chartObj.name = deviceData[i].conversion_action;
				chartObj.color = this.getColorFromColorConfig(i, 1);
				chartObj.y = deviceData[i][field];
				chartObjArray.push(chartObj);
			}
			chartData.chartObj = chartObjArray;
			chartData.seriesName = seletedLegend && seletedLegend[0] ? seletedLegend[0].displayName : field;
			chartData.seriesMetric = field;
			chartData.seriesHasData = this.checkFor(field);
			fieldChartArray.push(chartData);
		}
		return fieldChartArray;
	}

  generateAxisLabelsSoruce(): void {
		this.widgetsConfiguration.chartConfig.series[0].axisDataSource = [];
		let sum_conversions = this.deviceData.reduce((s, f) => s + Number(f['conversions']), 0);
		this.deviceData.forEach((daypart, index) => {
			const axisDataSrc = JSON.parse(JSON.stringify(this.initialAxisDataSrc));
			axisDataSrc.displayName = `${daypart.conversion_action.toLowerCase()}` + ' (' + ((daypart['conversions'] / sum_conversions) * 100).toFixed(2) + '%)';
			axisDataSrc.rowIdentity.value = daypart.conversion_action;
			axisDataSrc.colorPalette.color = this.daypartColors[index];
			if (daypart.conversions === '0') {
				axisDataSrc.showInSeries = false;
				axisDataSrc.dataLabels.enabled = false;
			}
			this.widgetsConfiguration.chartConfig.series[0].axisDataSource.push(axisDataSrc);
		});
	}

	getToolTipFormatter(): any {
		return function (): string {
			return `<div style='color: #FFFFFF; font-size: 14px'>
      <div style='display: flex; align-items: center;'>
					<div style='font-family: "Roboto"; font-weight: 400;'>${this.percentage.toFixed(2)}%</div>
					<div style='font-family: "Roboto"; font-weight: 400;'>&nbsp;(${Highcharts.numberFormat(this.y, 0, '', ',')})</div>
				</div>
				<div style='display: flex; align-items: center;'>
					<div style='color: ${
						this.color
					}; font-size: 27px; margin-right: 4px;'>●</div><div style='font-family: "Open Sans"; font-weight: 600; text-transform: capitalize;
          '>${this.key.substring(0, this.key.lastIndexOf(' '))}</div>
				</div>	
			</div>`;
		};
	}

}
